import { useTranslation } from "@next-platform/client-common-core";
import type RulebookAttachTarget from "@next-platform/client-common-core/rulebook/attach/RulebookAttachTarget";

import RulebookAttachTargetCard from "./RulebookAttachTargetCard";

export type RulebookAttachTargetListProps = {
  targets: RulebookAttachTarget[];
  rulebookId: string;
  selectedId: string | null;
  isAttaching: boolean;
  onSelectTarget: (id: string) => void;
};

const RulebookAttachTargetList = ({ targets, rulebookId, selectedId, isAttaching, onSelectTarget }: RulebookAttachTargetListProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-xs mt-sm"
      role="radiogroup"
      aria-label={t("rulebook:attach.description")}
      data-testid="RulebookAttachTargetList"
    >
      {targets.map((target) => (
        <RulebookAttachTargetCard
          key={target.id}
          target={target}
          rulebookId={rulebookId}
          isSelected={selectedId === target.id}
          onSelect={onSelectTarget}
          disabled={isAttaching}
        />
      ))}
    </div>
  );
};

export default RulebookAttachTargetList;
